<template>
    <div>
        <base-crud
                crudName="Categorias de Produtos"
                newText="Nova Categoria"
                :table="categoryProductTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="false"
                :enableEdit="true"
                :enableDelete="false"
                :enableView="false"
                :enableSetStatus="true"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                categoryProductTable: 'categoryProductTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'category_product_id', 'description', 'status', 'photo', 'actions'],
                tableData: [],
                options: {
                    sortable: ['id', 'category_product_id', 'description'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        'category_product_id': 'Categoria do Produto',
                        'description': 'Descrição',
                        'photo': 'Foto',
                        'actions': 'Ações'
                    },
                    templates: {
                        status: function (h, row, index) {
                            return row.status === 2 ? 'Inativo' : 'Ativo'
                        }
                    }
                },
                endPoint: 'categoryProduct/'
            }
        },
        components: {
            BaseCrud
        },
        computed: {
            postUrl() {
                return this.$store.getters.api + this.endPoint;
            }
        },
        methods: {

        }
    }
</script>

<style>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/CategoryProduct/Crud.vue